/* -----------------------------------------------------------------
   Turns the Variant Image Swatch King colour buttons into colour dots.

   The app hides the theme's own variant picker and re-renders the options
   itself. Its "Couleur" option is configured as a text button, so the theme
   swatch work in variant-button.liquid never reaches the shopper. This reads
   the value the app already puts on each item (orig-value) and paints it.

   Scope is deliberately narrow: only lists the app rendered in button mode
   (ul.swatch-view-button) whose option is a colour. If the app is ever set to
   render real swatches itself, that class is gone and this stops applying.

   Colours come from window.mcColorMap, printed by snippets/mc-color-map.liquid,
   so the app swatches and the theme swatches can never drift apart.
   ----------------------------------------------------------------- */
(function () {
  var UNKNOWN = '#c9c4bc';
  var COLOR_OPTION = /^(couleur|colour|color|farve|kleur)$/i;

  function buildMap(raw) {
    var map = {};
    String(raw || '').split('|').forEach(function (pair) {
      var at = pair.indexOf(':');
      if (at > 0) {
        map[pair.slice(0, at).trim()] = pair.slice(at + 1).trim();
      }
    });
    return map;
  }

  var MAP = buildMap(window.mcColorMap);

  function lookup(phrase) {
    return MAP[phrase] || MAP[phrase.split(' ')[0]] || '';
  }

  function resolve(value) {
    var raw = String(value || '').toLowerCase().split('(')[0].trim();
    if (!raw) return '';

    var hexes = raw.split('/').slice(0, 2).map(function (part) {
      return lookup(part.trim()) || UNKNOWN;
    });

    if (hexes.length > 1) {
      return 'linear-gradient(135deg, ' + hexes[0] + ' 0%, ' + hexes[0] +
        ' 50%, ' + hexes[1] + ' 50%, ' + hexes[1] + ' 100%)';
    }
    return hexes[0];
  }

  function decorate() {
    var lists = document.querySelectorAll('ul.swatch-view-button');

    Array.prototype.forEach.call(lists, function (list) {
      var labelId = list.getAttribute('aria-labelledby');
      var label = labelId ? document.getElementById(labelId) : null;
      if (!label || !COLOR_OPTION.test(label.textContent.trim())) return;

      list.classList.add('mc-appswatch-list');

      Array.prototype.forEach.call(list.querySelectorAll('.swatch-view-item'), function (item) {
        var button = item.querySelector('.swatch-button');
        if (!button || button.classList.contains('mc-appswatch')) return;

        var value = item.getAttribute('orig-value') || button.getAttribute('orig-value') || '';
        var background = resolve(value);
        if (!background) return;

        button.classList.add('mc-appswatch');
        button.style.background = background;
        if (!button.getAttribute('title')) {
          button.setAttribute('title', value);
        }
      });
    });
  }

  /* The app renders late and re-renders on every variant change, so watch for
     new markup instead of running once. Coalesced to one pass per frame. */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      decorate();
    });
  }

  decorate();
  document.addEventListener('DOMContentLoaded', decorate);

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();